import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60f3fec0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "absolute -left-10 top-6 pt-5"
}
const _hoisted_4 = { class: "bg-white p-4 rounded-lg dropdown w-max" }
const _hoisted_5 = { class: "flex w-full" }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-px bg-black bg-opacity-6 w-full my-4" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-px bg-black bg-opacity-6 w-full my-4" }, null, -1))
const _hoisted_9 = { class: "flex px-6" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PcItem = _resolveComponent("PcItem")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-14px text-everBlack2 transition-colors cursor-pointer flex flex-row items-center relative", `${_ctx.navbarTextColorHoverClass} ${_ctx.hoverd ? _ctx.navbarTextColorClass : ''}`]),
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hoverd = true)),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hoverd = false))
  }, [
    _createElementVNode("div", {
      class: "flex items-center",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.titleClick && _ctx.titleClick(...args)))
    }, [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.t(_ctx.title)), 1),
      _createElementVNode("img", {
        class: _normalizeClass(["transform", [_ctx.hoverd ? 'rotate-180' : 'rotate-0', _ctx.hoverd ? '' : 'opacity-0.85']]),
        src: require(`@/images/arrow-angle-down${_ctx.hoverd ? '-purple' : ''}.svg`)
      }, null, 10, _hoisted_2)
    ]),
    (_ctx.title === 'discover_dapps')
      ? (_openBlock(), _createBlock(_Transition, {
          key: 0,
          name: "fade"
        }, {
          default: _withCtx(() => [
            (_ctx.hoverd)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (dappItems, dappsIdnex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: dappsIdnex,
                          class: "mb-1 flex items-start flex-col flex-1 last:ml-2"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dappItems, (dappItem, dappIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: dappIndex,
                              class: "mt-1 h-9 first:mt-0 text-black text-opacity-0.65 text-14px hover:text-everPurple8 hover:text-opacity-100 w-full hover:bg-global-color/b/9 hover:bg-opacity-0.45 rounded-lg"
                            }, [
                              (dappItem.openNew)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: dappItem.to,
                                    target: "_blank",
                                    class: "px-6 h-full flex items-center"
                                  }, _toDisplayString(_ctx.t(dappItem.title)), 9, _hoisted_6))
                                : (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    to: dappItem.to,
                                    class: "w-full underline text-everPurple8 px-6 h-full flex items-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t(dappItem.title)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ]),
                    _hoisted_7,
                    _createElementVNode("div", null, [
                      _createVNode(_component_PcItem, {
                        class: "text-black text-opacity-0.65",
                        title: "developer_collection_from",
                        to: "https://docs.google.com/forms/d/e/1FAIpQLSfhzibF7SCA16gm_i3_S0e5xHtjew_h2NfRZzmvr7opjh2UBw/viewform",
                        "open-new": true,
                        img: "collection-from.svg",
                        "hover-img": "collection-from-purple.svg"
                      })
                    ]),
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.othersAppUrl, (appItem, appIndex) => {
                        return (_openBlock(), _createElementBlock("a", {
                          key: appIndex,
                          href: appItem.url,
                          target: "_blank",
                          class: "mr-4 last:mr-0 support-app"
                        }, [
                          _createElementVNode("img", {
                            src: require(`@/images/${appItem.img}`),
                            alt: ""
                          }, null, 8, _hoisted_11)
                        ], 8, _hoisted_10))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_Transition, {
          key: 1,
          name: "fade"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["absolute top-6 pt-5", _ctx.title === 'developers' ? '-left-10' : '-left-8'])
            }, [
              (_ctx.hoverd)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["bg-white rounded-lg dropdown w-max", _ctx.title === 'developers' ? 'p-4' : 'p-2'])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (itemArr, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemArr, (contentItem, itemIndex) => {
                          return (_openBlock(), _createBlock(_component_PcItem, {
                            key: itemIndex,
                            class: _normalizeClass(["first:mt-0", [_ctx.title === 'developers' ? 'mt-1' : 'mt-0.5',!contentItem.openNew ? contentItem.routeNames.includes(_ctx.routeName) ? 'text-everPurple8 text-opacity-100' : 'text-black text-opacity-0.65' : 'text-black text-opacity-0.65']]),
                            title: contentItem.title,
                            to: contentItem.to,
                            "open-new": contentItem.openNew,
                            img: contentItem.img,
                            "hover-img": contentItem.hoverImg
                          }, null, 8, ["class", "title", "to", "open-new", "img", "hover-img"]))
                        }), 128)),
                        _createElementVNode("div", {
                          class: _normalizeClass([index === _ctx.items.length - 1 ? 'hidden' : '', "border-t border-black border-opacity-6 my-4"])
                        }, null, 2)
                      ]))
                    }), 128))
                  ], 2))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }))
  ], 34))
}